import type { Entity } from '@backstage/catalog-model';

/**
 * True when the entity carries a `github.com/project-slug` annotation, which
 * is the keying information the Metrics plugin needs to query Timestream.
 * Mirrors the gating pattern used by isGithubActionsAvailable / isKubernetesAvailable.
 */
export function isMetricsAvailable(entity: Entity): boolean {
  return Boolean(entity.metadata.annotations?.['github.com/project-slug']);
}
